var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-shell',{attrs:{"title":_vm.$t('title'),"formsOnShell":_vm.formsOnShell,"successTexts":_vm.successTexts,"callbackRequest":_vm.createPhysicalWorldOrder,"makeBodyToRequest":_vm.makeBodyToRequest,"preValidation":_vm.preValidation},on:{"cancel":_vm.handleCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }